import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { LogsComponent } from './logs.component';
import { LogsLoginComponent } from './logs-login/logs-login.component';
import { LinkerService } from '@clavisco/linker';
import { TableModule } from '@clavisco/table';

@NgModule({
    declarations: [
        LogsComponent,
        LogsLoginComponent
    ],
    imports: [
        CommonModule,
        AppMaterialModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserModule,
        TableModule
    ],
    exports: [
        LogsComponent
    ],
    providers: [
        { provide: 'LinkerService', useClass: LinkerService }
    ],
})
export class LogsModule { }
